import React, {Component} from 'react';
import {toastr} from "react-redux-toastr";
import {copy_into_saved_design} from "../Dashboard/actions";
import {Redirect, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {Loader} from "../Wizard";

class Share extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            redirect_url: null,
            errored: false
        }
    }

    componentDidMount() {
        const id = this.props.match.params.id;
        const type = this.props.match.params.resource_type;
        if (id && type && type === 'design_template') {
            const url = global.config.server_path+'design/get_one';
            fetch(url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', body: JSON.stringify({id})})
                .then(resp => resp.json())
                .then(data => {
                    this.templateOnClick(data.data)
                })
                .catch(err => {
                    console.error(err);
                    toastr.error("Something went wrong :/");
                    this.setState({
                        errored: true
                    })
                })
        }
    }

    redirectPage = (url) => {
        this.setState({redirect_url: url, redirect: true})
    };

    templateOnClick = (template) => {
        const category = template.categories[0];
        const category_name = category ? '?category=' + encodeURIComponent(category._id) : ((template.categories && template.categories.length) ? '?category=' + encodeURIComponent(template.categories[0]._id) : '');
        this.props.copy_into_saved_design(template._id)
            .then(copied_design => {
                this.redirectPage('/designs/' + copied_design._id + '/edit' + category_name);
            })
            .catch(err => {
                toastr.error("Something went wrong :/");
                return Promise.reject(err);
            })
    };

    render() {

        let {redirect, redirect_url} = this.state;

        if (redirect) {
            return (<Redirect push to={redirect_url}/>)
        }

        if (this.state.errored) {
            return (
                <div>
                    Something went wrong :/
                </div>
            )
        }

        return (
            <div>
                <Loader show_loader={true}/>
            </div>
        )
    }
}

const mapStateToProps = function (state) {
    return {
        user: state.user
    }
};

const mapDispatchToProps = dispatch => ({
    copy_into_saved_design: (id) => dispatch(copy_into_saved_design(id))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Share));
